const RANKING_ITEMS = [
  { title: '近期最火：悬疑剧大盘点', tag: '热播', views: '362.5万', idx: 1 },
  { title: '搞笑合集：笑到停不下来', tag: '爆款', views: '298.1万', idx: 2 },
  { title: '美食探店：隐藏版好店推荐', tag: '热门', views: '254.7万', idx: 3 },
  { title: '旅行 Vlog：说走就走的旅程', tag: '推荐', views: '201.3万', idx: 4 },
  { title: '科技测评：最新数码产品上手', tag: '新鲜', views: '187.9万', idx: 5 },
  { title: '动漫精选：本季霸权番合集', tag: '热门', views: '165.2万', idx: 6 },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-trophy-line text-sm"></i>
            本周热榜
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            热门视频排行榜
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-md mx-auto">
            根据播放量与用户互动数据实时更新
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {RANKING_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-5 py-4 transition-colors duration-150 hover:bg-background-100/50 cursor-pointer ${
                idx < RANKING_ITEMS.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              {/* Rank Number */}
              <div className="w-8 h-8 rounded-full flex items-center justify-center shrink-0 font-heading text-base">
                {idx < 3 ? (
                  <span className={idx === 0 ? 'text-primary-500' : idx === 1 ? 'text-accent-500' : 'text-secondary-500'}>
                    {idx + 1}
                  </span>
                ) : (
                  <span className="text-foreground-500">{idx + 1}</span>
                )}
              </div>

              {/* Title */}
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground-950 truncate">{item.title}</div>
              </div>

              {/* Tag */}
              <span className="px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap shrink-0">
                {item.tag}
              </span>

              {/* Views */}
              <div className="flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap shrink-0">
                <i className="ri-eye-line"></i>
                <span>{item.views}</span>
              </div>

              {/* Arrow */}
              <div className="text-foreground-400 shrink-0">
                <i className="ri-arrow-right-s-line"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}